import { CustomFormFieldBase } from "./custom-form-field.type";

export class InputBoxFormControl extends CustomFormFieldBase<string> {
    override controlType = 'inputbox'; 
}
